
import { mapGetters } from 'vuex'
export default {
    name: 'PricePopover',
    props: {
        currentAction: {
            type: String,
            default: ''
        }
    },
    computed: {
        ...mapGetters({
            bargainImMessageTop: 'bargaining/bargainImMessageTop',
            userinfo: 'user/userinfo'
        }),
        title () {
            switch (this.currentAction) {
            case 'update':
                return '修改出价'
            case 'reBid':
                return '重新出价'
            case 'dicker':
            case 'bid':
                return '我的出价'
            case 'accept':
                return '同意出价'
            default:
                return ''
            }
        },
        shouldShowEstimatedPrice () {
            return !this.warnText && this.showEstimatedPrice && this.inputPrice && this.currentAction === 'dicker'
        }
    },
    data () {
        return {
            loading: false,
            counterOfferInfo: {},
            // 推荐出价
            recommendPrice: 0,
            // 是否显示推荐出价
            showRecommend: false,
            // 输入价格
            inputPrice: '',
            // 警告文本
            warnText: '',
            // 是否显示预估到手价
            showEstimatedPrice: false,
            // 预估到手价
            estimatedPrice: 0,
            // 代售费
            serviceFee: 0
        }
    },
    created () {
        this.getData()
    },
    methods: {
        async getData () {
            try {
                this.loading = true

                const params = {
                    action: {
                        bargainId: this.bargainImMessageTop.id,
                        buyerId: this.bargainImMessageTop.buyerId,
                        goodsNo: this.bargainImMessageTop.goodsNo,
                        sellerId: this.bargainImMessageTop.sellerId
                    }
                }
                // 调用接口获取当前出价信息
                const res = await this.$api.bargainImCounterOfferInfoAPI(params)
                if (res.success) {
                    this.counterOfferInfo = res.data
                    const disPrice = (res.data.sellerPrice - res.data.buyerPrice) * 0.55
                    this.recommendPrice = Math.ceil(res.data.buyerPrice + disPrice)
                    this.showRecommend = disPrice >= 10
                    // 提前看看代售费
                    const params = {
                        action: {
                            goodsPrice: Number(res.data?.buyerPrice),
                            gameId: this.bargainImMessageTop?.gameId,
                            goodsCatalogueId: this.bargainImMessageTop?.goodsCategoryId,
                            goodsNo: this.bargainImMessageTop?.goodsNo
                        }
                    }
                    this.$api.getBargainFee(params).then(({ success, data }) => {
                        if (success) {
                            this.serviceFee = data.serviceFee || 0
                            this.estimatedPrice = res.data?.buyerPrice - data.serviceFee
                        }
                    })
                    this.showEstimatedPrice = true
                }
            } catch (error) {
                console.error('获取当前出价信息异常:', error)
            } finally {
                this.loading = false
            }
        },
        handleClose () {
            // 关闭弹窗
            this.$parent.pricePopoverVisible2 = false
        },
        // 一键输入
        handleRecommend () {
            this.inputPrice = this.recommendPrice
            this.handlePriceInput(this.recommendPrice)
        },
        // 处理价格输入
        handlePriceInput (val) {
            console.log(val, 'val')
            if (!val) {
                this.warnText = ''
                return
            }

            // 根据不同的 currentAction 和 isBuyer 处理不同的校验
            switch (this.currentAction) {
            // 修改出价
            case 'update': {
                // 获取商品原价和最低价格比例
                const goodsPrice = this.counterOfferInfo.goodsPrice
                const goodsPriceRate = this.bargainImMessageTop?.goodsPriceRate || 65
                const minPrice = goodsPrice * goodsPriceRate / 100
                if (val > goodsPrice || val < minPrice) {
                    this.warnText = `请输入￥${minPrice}-${goodsPrice}之间的价格`
                } else {
                    this.warnText = ''
                }
                break
            }
            // 卖家还价
            case 'dicker': {
                const params = {
                    action: {
                        goodsPrice: Number(val),
                        gameId: this.bargainImMessageTop?.gameId,
                        goodsCatalogueId: this.bargainImMessageTop?.goodsCategoryId,
                        goodsNo: this.bargainImMessageTop?.goodsNo
                    }
                }
                this.$api.getBargainFee(params).then(res => {
                    if (res.success) {
                        const serviceFee = res.data.serviceFee || 0
                        const goodsPrice = this.counterOfferInfo.goodsPrice
                        const price = parseFloat(val)

                        if (isNaN(price)) {
                            this.warnText = '请输入有效的价格'
                            return
                        }

                        // 价格校验逻辑
                        if (price < serviceFee) {
                            this.warnText = `还价需高于最低可售卖价格￥${serviceFee}`
                            this.showEstimatedPrice = false
                        } else if (this.counterOfferInfo.sellerPrice && price > this.counterOfferInfo.sellerPrice) {
                            this.warnText = `出价不能高于上次出价￥${this.counterOfferInfo.sellerPrice}`
                            this.showEstimatedPrice = false
                        } else if (price > goodsPrice) {
                            this.warnText = `出价不能高于商品原价￥${goodsPrice}`
                            this.showEstimatedPrice = false
                        } else {
                            this.warnText = ''
                            // 更新预估到手价数据
                            this.serviceFee = serviceFee
                            this.estimatedPrice = price - serviceFee
                            this.showEstimatedPrice = true
                        }
                    }
                })
                break
            }
            // 买家出价
            case 'bid': {
                const { buyerPrice, goodsPrice } = this.counterOfferInfo || {}
                const price = parseFloat(val)

                if (isNaN(price)) {
                    this.warnText = '请输入有效的价格'
                    return
                }

                if (price > goodsPrice) {
                    this.warnText = `出价不能高于商品原价￥${goodsPrice}`
                } else if (price < buyerPrice) {
                    this.warnText = `出价不能低于上次出价￥${buyerPrice}`
                } else {
                    this.warnText = ''
                }
                break
            }
            default:
                break
            }
        },
        checkPrice () {
            return new Promise((resolve, reject) => {
                if (this.inputPrice < this.counterOfferInfo.buyerPrice) {
                    const model = this.$pzDialog(
                        {
                            width: '450px',
                            title: '温馨提示',
                            titleCenter: true,
                            cancelButtonText: '确定',
                            confirmButtonText: '我再想想',
                            content: `当前还价低于买家出价，确认还¥${this.inputPrice}吗？`,
                            contentCenter: true,
                            onConfirm: () => {
                                model.remove()
                                return resolve()
                            },
                            onCancel: err => {
                                model.remove()
                                return reject(err)
                            }
                        },
                        this
                    )
                } else {
                    return reject()
                }
            })
        },
        // 提交
        handleSubmit () {
            if (this.warnText || !this.inputPrice) {
                this.$message.error(this.warnText || '请输入价格')
                return
            }
            switch (this.currentAction) {
            case 'update': {
                // 修改出价
                this.$api.bargainImBuyerUpdatePriceAPI({
                    action: {
                        bargainId: this.bargainImMessageTop.id,
                        buyerId: this.bargainImMessageTop.buyerId,
                        goodsNo: this.bargainImMessageTop.goodsNo,
                        price: parseFloat(this.inputPrice),
                        sellerId: this.bargainImMessageTop.sellerId
                    }
                }).then(({ success, code, info }) => {
                    this.$trackEvent({ eventType: 'click', trackParams: { eventName: '修改出价', userId: this.userinfo.id, goodsNo: this.bargainImMessageTop.goodsNo, isSuccess: success } })
                    if (success) {
                        this.$message.success('修改出价成功')
                        this.handleClose()
                    } else {
                        if (code === 'BARGAIN_IM_GOODS_PRICE_CHANGE') {
                            this.handleClose()
                        }
                        this.$message.error(info)
                    }
                })
                break
            }
            case 'dicker': {
                // 卖家还价
                this.checkPrice().catch(() => {
                    this.$api.bargainImSellerCounterOfferAPI({
                        action: {
                            bargainId: this.bargainImMessageTop.id,
                            buyerId: this.bargainImMessageTop.buyerId,
                            goodsNo: this.bargainImMessageTop.goodsNo,
                            price: parseFloat(this.inputPrice),
                            sellerId: this.bargainImMessageTop.sellerId
                        }
                    }).then(({ success, code, info, data }) => {
                        this.$trackEvent({ eventType: 'click', trackParams: { eventName: '卖家还价', isSuccess: success, ...data?.sellerReply }  })
                        if (success) {
                            this.$message.success('还价成功')
                            this.handleClose()
                        } else {
                            if (code === 'BARGAIN_IM_GOODS_PRICE_CHANGE') {
                                this.handleClose()
                            }
                            this.$message.error(info)
                        }
                    })
                })
                break
            }
            case 'bid': {
                // 买家出价
                this.$api.bargainImBuyerCounterOfferAPI({
                    action: {
                        againOffer: false,
                        bargainId: this.bargainImMessageTop.id,
                        buyerId: this.bargainImMessageTop.buyerId,
                        goodsNo: this.bargainImMessageTop.goodsNo,
                        price: parseFloat(this.inputPrice),
                        sellerId: this.bargainImMessageTop.sellerId
                    }
                }).then(({ success, code, info }) => {
                    if (success) {
                        this.$message.success('出价成功')
                        this.handleClose()
                    } else {
                        if (code === 'BARGAIN_IM_GOODS_PRICE_CHANGE') {
                            this.handleClose()
                        }
                        this.$message.error(info)
                    }
                })
                break
            }
            case 'reBid': {
                // 重新出价
                const params = {
                    action: {
                        goodsNo: this.bargainImMessageTop.goodsNo,
                        price: parseFloat(this.inputPrice),
                        buyerId: this.userinfo.id
                    }
                }
                console.log(params, 'params', this.userinfo)
                this.$api.bargainImCreateAPI(params).then(({ success, code, info, operate }) => {
                    if (success) {
                        this.$message.success('重新出价成功')
                        this.handleClose()
                        const { sellerAgree, sellerReject, sellerReply } = operate || {}
                        sellerAgree && this.$trackEvent({ eventType: 'click', trackParams: { eventName: '同意砍价', ...sellerAgree } })
                        sellerReject && this.$trackEvent({ eventType: 'click', trackParams: { eventName: '卖家拒绝', ...sellerReject } })
                        sellerReply && this.$trackEvent({ eventType: 'click', trackParams: { eventName: '砍价回复', ...sellerReply } })
                    } else {
                        if (code === 'BARGAIN_IM_REPETITION') {
                            const model = this.$pzDialog(
                                {
                                    width: '450px',
                                    title: '温馨提示',
                                    titleCenter: true,
                                    confirmButtonText: '',
                                    cancelButtonText: '我知道了',
                                    content: info,
                                    contentCenter: true,
                                    showCancelButton: false,
                                    onCancel: () => {
                                        model.remove()
                                    }
                                },
                                this
                            )
                            this.handleClose()
                        }
                        if (code === 'BARGAIN_IM_GOODS_PRICE_CHANGE') {
                            this.handleClose()
                        }
                        this.$message.error(info)
                    }
                })
                break
            }
            default:
                break
            }
        },
        // 同意出价
        handleAccept () {
            this.$api.bargainImSellerAgreeAPI({
                action: {
                    bargainId: this.bargainImMessageTop.id,
                    buyerId: this.bargainImMessageTop.buyerId,
                    goodsNo: this.bargainImMessageTop.goodsNo,
                    sellerId: this.bargainImMessageTop.sellerId
                }
            }).then(({ success, info }) => {
                this.$trackEvent({ eventType: 'click', trackParams: { eventName: '同意出价', userId: this.userinfo?.id, goodsNo: this.bargainImMessageTop?.goodsNo, isSuccess: success } })
                this.handleClose()
                if (success) {
                    this.$message.success('同意出价成功')
                } else {
                    this.$message.error(info)
                }
            })
        }
    }
}
